import { render, staticRenderFns } from "./InformationField.vue?vue&type=template&id=36055d7b&"
import script from "./InformationField.vue?vue&type=script&lang=ts&setup=true&"
export * from "./InformationField.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36055d7b')) {
      api.createRecord('36055d7b', component.options)
    } else {
      api.reload('36055d7b', component.options)
    }
    module.hot.accept("./InformationField.vue?vue&type=template&id=36055d7b&", function () {
      api.rerender('36055d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuInformation/components/InformationField.vue"
export default component.exports